import script from "./company_titles.vue?vue&type=script&setup=true&lang=js"
export * from "./company_titles.vue?vue&type=script&setup=true&lang=js"

import "./company_titles.vue?vue&type=style&index=0&id=378734dc&lang=css"

const __exports__ = script;

export default __exports__